import AbstractFilter from '@/classes/filters/AbstractFilter'

export default class TextFilter extends AbstractFilter {
  /**
   * Create new text filter
   *
   * @param {String} key
   * @param {String} label
   * @param {String} property
   * @param {String} [value]
   */
  constructor (key, label, property, value) {
    super(key, label, property, value)

    this.type = 'TextFilter'
  }

  /**
   * Does this filter have a value?
   *
   * @return {boolean}
   */
  hasValue () {
    return this.value !== null && typeof this.value !== 'undefined' && this.value !== ''
  }
}
